export default __webpack_public_path__ + "content/5ca455d9523062f1bd3847c191e60147.svg";